import styled from 'styled-components'
import { AiOutlineCloseCircle } from 'react-icons/ai'
import { Button } from 'react-bootstrap'

export const CloseCircle = styled(AiOutlineCloseCircle)`
  position: absolute;  
  font-size: 1.5rem;
  right: 0px;
  top: -25px;
  background-color: white;
  border-radius: 50px;
`;

export const InfoButton = styled(Button)`
  all: unset;

  &:hover,
  &:visited,
  &:focus,
  &:active {
    all: unset !important;
  }
`;
